import { render, staticRenderFns } from "./transportDetail.vue?vue&type=template&id=69e236c0"
import script from "./transportDetail.vue?vue&type=script&lang=js"
export * from "./transportDetail.vue?vue&type=script&lang=js"
import style0 from "./transportDetail.vue?vue&type=style&index=0&id=69e236c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports